import React from "react";
import { isMobile } from "react-device-detect";
import { Redirect, useLocation } from "react-router-dom";

import { landingRoute } from "~/common/landing-route";
import { Loader } from "~/components/ui/loader";
import { selectUser, selectUserIsLoading } from "~/slices/user";
import { useAppSelector } from "~/store";

import { PREV_PATHNAME_STORAGE_KEY } from "./welcome";

function CatchAll() {
  const user = useAppSelector(selectUser);
  const userIsLoading = useAppSelector(selectUserIsLoading);
  const location = useLocation();

  if (userIsLoading) {
    // <Welcome /> component already displays a <Loader /> for every page under "/pages" path.
    return location.pathname.startsWith("/pages") ? null : <Loader />;
  }

  if (Object.keys(user).length == 0) {
    return <Redirect to="/login" />;
  }

  if (!user.has_signed_offer) {
    return <Redirect to="/pages/offer" />;
  }

  return <Redirect to={window.localStorage.getItem(PREV_PATHNAME_STORAGE_KEY) || (!isMobile ? "/pages/home" : landingRoute())} />;
}

export default CatchAll;
